import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'langchain-prompt-template',
  version: '1.0.0',
  properties: [
    {
      key: 'template',
      label: 'Template',
      type: 'string',
      required: true,
      typeOptions: {
        rows: 6,
      },
      placeholder: 'You are a {role}. Answer the following: {question}',
      description: 'Use {variable} for placeholders',
    },
    {
      key: 'variables',
      label: 'Variables',
      type: 'json',
      placeholder: '{"role": "assistant", "question": "What is AI?"}',
      description: 'Values to fill in the template',
    },
  ],
};

export default schema;
